<canvas #lottieCanvas class="w-full h-full"></canvas>
